import React from 'react';
import { Link } from 'react-router-dom';

function TermesConditionsPage() {
    return (
        <main>
            {/* Breadcrumb Section */}
            <section className="breadcrumb-area breadcrumb-bg" style={{ backgroundImage: "url('img/bg/breadcrumb_bg.jpg')" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h2 className="title">Termes & Conditions</h2>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
                                        <li className="breadcrumb-item active" aria-current="page">Termes & Conditions</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Content Section */}
            <section className="terms-conditions-area" style={{ padding: '100px 0', backgroundColor: '#fff' }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="terms-conditions-content">
                                <h3 className="title mb-4">Termes & Conditions</h3>
                                <p className="mb-2">Mise à jour 18/12/2025</p>
                                <p className="mb-4">(Conditions Générales d’Utilisation et de Vente)</p>

                                <h4 className="mt-4 mb-3">1. Présentation de la marque</h4>
                                <p>Le site Kaki.tn est exploité par Kaki, spécialisée dans la conception et la vente de vêtements et accessoires pour animaux de compagnie.</p>
                                <p>Toute utilisation du site implique l’acceptation pleine et entière des présentes Conditions Générales.</p>

                                <h4 className="mt-4 mb-3">2. Objet</h4>
                                <p>Les présentes conditions définissent :</p>
                                <ul>
                                    <li>Les modalités d’utilisation du site web</li>
                                    <li>Les conditions de commande, de paiement, de livraison et de retour</li>
                                    <li>Les droits et obligations respectifs du client et de Kaki</li>
                                </ul>

                                <h4 className="mt-4 mb-3">3. Accès au site</h4>
                                <p>L’accès au site est libre et gratuit. Toutefois, Kaki se réserve le droit de suspendre, limiter ou interrompre l’accès au site à tout moment pour maintenance ou mise à jour, sans obligation de préavis.</p>

                                <h4 className="mt-4 mb-3">4. Produits</h4>
                                <p>Les produits proposés sont des vêtements et accessoires destinés aux animaux de compagnie.</p>
                                <p>Chaque article est présenté avec une description détaillée. Malgré le soin apporté aux visuels et aux informations, de légères variations (couleur, texture) peuvent apparaître.</p>
                                <p>Le client est responsable du choix de la taille et de l’adéquation du produit à son animal.</p>

                                <h4 className="mt-4 mb-3">5. Commandes</h4>
                                <p>Toute commande passée sur le site constitue une acceptation ferme et définitive des présentes conditions.</p>
                                <p>Kaki se réserve le droit de refuser ou d’annuler toute commande en cas de :</p>
                                <ul>
                                    <li>Litige antérieur avec le client</li>
                                    <li>Non-paiement ou paiement partiel</li>
                                    <li>Suspicion de fraude</li>
                                </ul>

                                <h4 className="mt-4 mb-3">6. Prix</h4>
                                <p>Les prix sont indiqués en TND, toutes taxes comprises (sauf mention contraire).</p>
                                <p>Les frais de livraison sont précisés avant validation de la commande.</p>

                                <h4 className="mt-4 mb-3">7. Paiement</h4>
                                <p>Le paiement s’effectue via les moyens proposés sur le site.</p>
                                <p>Les transactions sont sécurisées et les données bancaires ne sont jamais conservées par Kaki</p>
                                <p>Toute commande n’est considérée comme validée qu’après confirmation du paiement.</p>

                                <h4 className="mt-4 mb-3">8. Livraison</h4>
                                <p>Les livraisons sont effectuées à l’adresse indiquée par le client lors de la commande.</p>
                                <p>Les délais de livraison sont donnés à titre indicatif ( entre 48-72 heures ) en général. Kaki ne pourra être tenue responsable des retards dus à des circonstances indépendantes de sa volonté (transporteur, force majeure, conditions climatiques, etc.).</p>

                                <h4 className="mt-4 mb-3">9. Politique de retour et d’échange</h4>
                                <p>La politique de retour est définie dans une section dédiée ( politique de retour et d’échange) du site et fait partie intégrante des présentes Conditions Générales.</p>
                                <p>Pour des raisons d’hygiène et de sécurité, les vêtements pour animaux portés plus qu’une fois pour un test ne peuvent être repris.</p>

                                <h4 className="mt-4 mb-3">10. Responsabilité</h4>
                                <p>Kaki ne saurait être tenue responsable :</p>
                                <ul>
                                    <li>D’une mauvaise utilisation des produits</li>
                                    <li>De réactions ou dommages liés à une utilisation non conforme</li>
                                </ul>
                                <p>Il appartient au client de surveiller son animal lors de l’utilisation des produits.</p>

                                <h4 className="mt-4 mb-3">11. Propriété intellectuelle</h4>
                                <p>L’ensemble des contenus présents sur le site Kaki, incluant, sans s’y limiter, les textes, images, photographies, illustrations, logos, éléments graphiques, designs, vidéos, chartes visuelles, ainsi que tout autre contenu, est la propriété exclusive de la marque Kaki, dûment enregistrée et protégée auprès de l’INNORPI (Institut National de la Normalisation et de la Propriété Industrielle) sous licence « TN/T/2021/000717 ».</p>
                                <p>Ces éléments sont protégés par les lois tunisiennes et internationales relatives à la propriété intellectuelle et au droit d’auteur.</p>
                                <p>Toute reproduction, représentation, modification, adaptation, diffusion, exploitation ou utilisation, totale ou partielle, sur quelque support que ce soit, sans autorisation écrite préalable de Kaki, est strictement interdite et constitue une contrefaçon, susceptible d’entraîner des poursuites civiles et pénales, ainsi que le paiement de dommages et intérêts.</p>
                                <p>Kaki se réserve le droit d’engager toute action légale nécessaire afin de faire respecter ses droits de propriété intellectuelle.</p>

                                <h4 className="mt-4 mb-3">12. Données personnelles</h4>
                                <p>Les données personnelles collectées sont utilisées uniquement dans le cadre du traitement des commandes et de la relation client.</p>
                                <p>Kaki s’engage à respecter la confidentialité des données conformément à la réglementation en vigueur.</p>

                                <h4 className="mt-4 mb-3">13. Force majeure</h4>
                                <p>La responsabilité de Kaki ne pourra être engagée en cas de force majeure empêchant l’exécution de ses obligations.</p>

                                <h4 className="mt-4 mb-3">14. Modification des conditions</h4>
                                <p>Kaki se réserve le droit de modifier les présentes Conditions Générales à tout moment.</p>
                                <p>Les conditions applicables sont celles en vigueur à la date de la commande.</p>

                                <h4 className="mt-4 mb-3">15. Droit applicable et litiges</h4>
                                <p>Les présentes Conditions Générales sont soumises au droit applicable en vigueur.</p>
                                <p>En cas de litige, une solution amiable sera privilégiée avant toute action judiciaire.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default TermesConditionsPage;
